(ns minorodata.components.admin.vcs
  (:require
   ["lucide-react" :refer [GithubIcon RefreshCcwIcon]
    :as lucide]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.app.utils :refer [assoc-some]]
   [minorodata.components.spinner.core :as spinner]
   [mold-forms.core :as form-component]
   [mold-forms.model :refer [->form-model]]
   [re-posh.core :as re-posh]
   [react :as react]
   [ui.accordion]
   [ui.button :refer [button]]
   [ui.fields :as fields]
   [ui.typography :as typography]))

(defn pick-vcs-provider []
  [:div {:class "flex flex-col gap-2 aspect-[1.85] h-36 w-full"}
   [typography/h4 "Pick your VCS provider"]
   [:div {:class "flex border *:flex-1 *:last:border-l h-full rounded"}
    [button {:variant :empty-transparent
             :class   "rounded-none"
             :wrapper-class "flex flex-col items-center gap-1"
             :on-click #(dispatch [:vcs.api/install-github])}
     [:> GithubIcon {:size 48}]
     [:span "Github"]]
    [button {:variant :empty-transparent
             :class   "rounded-none"
             :wrapper-class "flex flex-col items-center gap-1"
             :on-click #(dispatch [:vcs.api/install-azure])}
     [:img {:src "/img/ui/azure-devops.svg" :alt "Azure DevOps logo" :class "inline-block h-12"}]
     "Azure DevOps"]]])

(defn vcs-details [{:keys [config repos]}]
  [:div {:class "flex flex-col gap-4"}
   [:header {:class "flex items-center justify-between gap-2"}
    (if (= (:vcs-config/provider config) "github")
      [:div {:class "flex gap-1"}
       [:> GithubIcon {:size 20}]
       [typography/h4 "Github"]]
      [:div {:class "flex gap-1"}
       [:img {:src "/img/ui/azure-devops.svg" :alt "Azure DevOps logo" :class "inline-block h-5"}]
       [typography/h4 "Azure DevOps"]])
    (when @(re-posh/subscribe [:unleash/is-enabled "fe.git-full-sync"])
      [:div {:class "flex gap-1"}
       (when (#{"bidirectional" "outbound"} (:vcs-config/sync-mode config))
         [button {:variant  :secondary
                  :size     :small
                  :icon     RefreshCcwIcon
                  :on-click #(dispatch [:vcs.api/full-sync-outbound])}
          "Sync all outbound"])
       (when (#{"bidirectional" "inbound"} (:vcs-config/sync-mode config))
         [button {:variant  :secondary
                  :size     :small
                  :icon     RefreshCcwIcon
                  :on-click #(dispatch [:vcs.api/full-sync-inbound])}
          "Sync all inbound"])])]
   [form-component/form
    (->form-model
     {:id :vcs-config-form
      :fields [{:name :repo-id
                :value (str (:vcs-config/repo-id config))
                :process str}
               {:name :branch
                :value (:vcs-config/branch config)}
               {:name :sync-mode
                :value (or (:vcs-config/sync-mode config) "disabled")
                :process identity}]
      :on-submit (fn [form-state]
                   (let [{:keys [repo-id branch sync-mode]} (form-component/model->fields form-state)
                         selected-repo (->> repos
                                            (filter #(= (str (:vcs-repo/repo-id %)) repo-id))
                                            first)
                         data (assoc-some {:repo-id   repo-id
                                           :branch    branch
                                           :sync-mode sync-mode}
                                          {:org        (:vcs-repo/org selected-repo)
                                           :project    (:vcs-repo/project selected-repo)
                                           :project-id (:vcs-repo/project-id selected-repo)})]
                     (dispatch [:vcs.api/update-config data])))})
    (fn [fields _ on-submit]
      [:form {:class "flex flex-col gap-4"
              :on-submit on-submit}
       [fields/select {:field (get fields :repo-id)
                       :label "Repository"
                       :native false
                       :options (mapv (fn [{:vcs-repo/keys [repo-id full-name archived]}]
                                        {:value (str repo-id)
                                         :text full-name
                                         :disabled archived})
                                      repos)}]
       [fields/input {:label "Branch"
                      :field (get fields :branch)}]
       [fields/radio-group {:id      "sync-mode"
                            :name    "sync-mode"
                            :label   "Sync mode"
                            :value   (:value (get fields :sync-mode))
                            :options [{:value "disabled" :text "Disabled"}
                                      {:value "bidirectional" :text "Bidirectional"}
                                      {:value "outbound" :text "Outbound"}
                                      {:value "inbound" :text "Inbound"}]
                            :on-value-change #((:action (get fields :sync-mode)) %)}]
       [:div {:class "flex gap-2 justify-between mt-2"}
        [button {:variant :error-border
                 :on-click #(dispatch [:vcs.api/delete-config])}
         "Delete configuration"]
        [button {:type :submit
                 :variant :primary}
         "Save"]]])]])

(def provider-messages
  {"github" "Github successfully installed"
   "azure" "Azure DevOps successfully installed"})

(defn version-control-settings' [{:keys [config repos loading? query]}]
  (react/useEffect
   (fn []
     (dispatch [:vcs.events/init])
     (when-let [message (get provider-messages (:vcs-installed query))]
       (dispatch [:app.events/add-snack :success message])
       (dispatch [:app.events/navigate-query {:vcs-installed nil}]))
     js/undefined)
   #js [])

  [:div
   (cond
     loading?
     [:div {:class "flex items-center justify-center gap-2 aspect-[1.85] h-36 w-full"}
      [spinner/with-text "Loading VCS configuration..."]]

     (not (:vcs-config/provider config))
     [pick-vcs-provider]

     :else
     [vcs-details {:config config :repos repos}])])

(defn version-control-settings []
  (let [config   @(re-posh/subscribe [:vcs-config/pull])
        repos    @(re-posh/subscribe [:vcs-repo/pull-many])
        loading? @(re-posh/subscribe [:mold-http/loading? :vcs.api/get-config])
        query    @(re-posh/subscribe [:app-route/prop :app-route/query])]
    [:f> version-control-settings' {:config   config
                                    :repos    repos
                                    :loading? loading?
                                    :query    query}]))
